export const navAccountButtonComponent = {
  key: 'navAccountButtonComponent',
  name: 'Nav Account Button Dept-Component',
  siteIdentifier: 'global',

  profileAriaLabel: 'Profile',
};
